import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import CatalogView from '@/views/CatalogView.vue'

import CheckoutView from '../views/CheckoutView.vue'
import ProcessedView from '../views/ProcessedView.vue'
import ProfileView from '../views/ProfileView.vue'
import ReserveView from '../views/ReserveView.vue'
import FeedbackView from '../views/FeedbackView.vue'
import QrPayView from '../views/QrPayView.vue'
import VacationView from '../views/VacationView.vue'
import ShopView from '../views/ShopView.vue'
import FavoritesView from '../views/FavoritesView.vue'
import CartView from '../views/CartView.vue'
import FoxStep from '../views/performances/FoxStep.vue'
import DeadlyParty from '../views/performances/DeadlyParty.vue'
import Merak from '../views/performances/Merak.vue'
import PerfomancesView from '../views/PerfomancesView.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/checkout',
        name: 'checkout',
        component: CheckoutView
    },
    {
        path: '/processed',
        name: 'processed',
        component: ProcessedView
    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfileView
    },
    {
        path: '/reserve',
        name: 'reserve',
        component: ReserveView
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: FeedbackView
    },
    {
        path: '/qrpay',
        name: 'qrpay',
        component: QrPayView
    },
    {
        path: '/vacation',
        name: 'vacation',
        component: VacationView
    },
    {
        path: '/favorites',
        name: 'favorites',
        component: FavoritesView
    },
    {
        path: '/shop/:code',
        name: 'shop',
        component: ShopView
    },
    {
        path: '/cart',
        name: 'cart',
        component: CartView
    },
    {
        path: '/performances',
        name: 'performances',
        component: PerfomancesView
    },
    {
        path: '/performances/fox_step',
        name: 'fox_step',
        component: FoxStep
    },
    {
        path: '/performances/deadly_party',
        name: 'deadly_party',
        component: DeadlyParty
    },
    {
        path: '/performances/merak',
        name: 'merak',
        component: Merak
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {el: to.hash}
        } else {
            return { top: 0 }
        }
    }
})

export default router
